/*
 * Infinite scroll for the blog index.
 *
 * This is progressive enhancement over a real paginated link, not a
 * replacement for it. The markup ships a working <a href="?page=2">, so the
 * archive stays crawlable and usable with JavaScript off or broken; this
 * file only takes over the link's job once it can.
 *
 * Each fetch pulls the next page and lifts the children of
 * [data-nb-journal-grid] out of it, which is why the grid cards are
 * self-contained in the Liquid template.
 *
 * Two deliberate limits:
 *  - After AUTO_LOAD_LIMIT automatic loads the button goes back to being a
 *    button. Endless auto-loading makes the footer unreachable, and the
 *    reader loses any sense of how much is left.
 *  - A failed fetch restores the link rather than retrying, so a reader on
 *    a flaky connection always has a way forward.
 */
(function () {
  'use strict';

  var AUTO_LOAD_LIMIT = 3;

  var grid = document.querySelector('[data-nb-journal-grid]');
  var more = document.querySelector('[data-nb-journal-more]');
  if (!grid || !more) return;

  var link = more.querySelector('[data-nb-journal-next]');
  var spinner = more.querySelector('[data-nb-journal-spinner]');
  var status = document.querySelector('[data-nb-journal-status]');
  if (!link) return;

  var loading = false;
  var autoLoads = 0;
  var observer = null;

  function announce(message) {
    if (status) status.textContent = message;
  }

  function setBusy(isBusy) {
    loading = isBusy;
    more.classList.toggle('is-loading', isBusy);
    if (spinner) spinner.hidden = !isBusy;
  }

  function finish() {
    if (observer) observer.disconnect();
    more.parentNode.removeChild(more);
    announce('All articles loaded.');
  }

  function load(auto) {
    if (loading || !link) return;
    var url = link.getAttribute('href');
    if (!url) return;

    setBusy(true);
    announce('Loading more articles…');

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-nb-journal-grid]');
        if (!nextGrid) { finish(); return; }

        var added = 0;
        while (nextGrid.firstElementChild) {
          grid.appendChild(nextGrid.firstElementChild);
          added++;
        }

        // Advance to the page after the one just consumed, or stop.
        var nextLink = doc.querySelector('[data-nb-journal-next]');
        if (nextLink && nextLink.getAttribute('href')) {
          link.setAttribute('href', nextLink.getAttribute('href'));
          setBusy(false);
          announce(added + ' more articles loaded.');
          if (auto) {
            autoLoads++;
            // Hand control back to the reader before the footer becomes
            // unreachable.
            if (autoLoads >= AUTO_LOAD_LIMIT && observer) {
              observer.disconnect();
              observer = null;
              more.classList.add('is-manual');
            }
          }
        } else {
          setBusy(false);
          announce(added + ' more articles loaded. All articles loaded.');
          finish();
        }
      })
      .catch(function () {
        // Leave the link intact so the reader can still reach the next page.
        setBusy(false);
        more.classList.add('is-manual');
        if (observer) { observer.disconnect(); observer = null; }
        announce('Could not load more articles. Use the link to continue.');
      });
  }

  link.addEventListener('click', function (event) {
    event.preventDefault();
    load(false);
  });

  if ('IntersectionObserver' in window) {
    more.classList.add('is-auto');
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { load(true); break; }
      }
    }, { rootMargin: '600px 0px' });
    observer.observe(more);
  } else {
    more.classList.add('is-manual');
  }
})();
